import styled, { css } from 'styled-components';
import { BODY } from '@nokia-csf-uxr/freeform-design-tokens/tokens/typography';
import { SPACING_8 } from '@nokia-csf-uxr/freeform-design-tokens/tokens/spacing';

const TEXT_STYLE = css`
  ${BODY}
  padding: 0 ${SPACING_8};
  height: 2.5rem;
  line-height: 2.5rem;
  text-transform: uppercase;
  overflow: hidden;
`;

export default {
  StatusIndicator: styled.div`
    width: 100%;
    position: relative;
    line-height: 2.5rem;
    overflow: hidden;
    ${({ status, $theme }) =>
    css`
        background-color: ${status === 'cleared' ? $theme.cleared.background : $theme.warning.background};
      `};
    & svg * {
      ${({ status, $theme }) =>
    css`
          fill: ${status === 'cleared' ? $theme.cleared.icon : $theme.warning.icon};
        `};
    }
    ${({ $rtl }) =>
    css`
        direction: ${$rtl ? 'rtl' : 'ltr'};
      `};
  `,
  ClearedOverlay: styled.div`
    position: absolute;
    top: 0;
    display: flex;
    justify-content: center;
    z-index: 1;
    overflow: hidden;
    transform: translateX(-50%);
    left: 50%;
    border-radius: 2.5rem;
    min-width: 0.125rem;
    ${({ $theme }) =>
    css`
        background-color: ${$theme.cleared.background};
      `};
  `,
  OverlyContent: styled.div`
    display: flex;
    justify-content: center;
    width: fit-content;
    z-index: 1;
    overflow: hidden;
    min-width: 0.125rem;
  `,
  WarningOverlay: styled.div`
    position: absolute;
    top: 0;
    height: 2.5rem;
    display: flex;
    justify-content: center;
    width: 100%;
    ${({ $theme }) =>
    css`
        background-color: ${$theme.warning.background};
      `};
  `,
  StatusIndicatorText: styled.span`
    ${TEXT_STYLE}
    ${({ status, $theme }) =>
    css`
        color: ${status === 'cleared' ? $theme.cleared.content : $theme.warning.content};
      `};
  `,
  IconWrapper: styled.div`
    margin: auto 0;
  `
};
